import React, { useEffect, useRef } from 'react'
import { useFrame } from 'react-three-fiber'
import { cloneDeep } from 'lodash'

import * as THREE from 'three'

import pointShader from './shader'

const shapes = {
  hex: 6,
  triangle: 3
}

export default function (props) {
  const parentRef = useRef()
  const geoRef = useRef()

  const [positions, colors, scales, opacities, indexes] = props.buffers

  useEffect(() => {
    const parentRefCurrent = parentRef.current
    const t = new THREE.CircleBufferGeometry(2, shapes[props.shape])
    t.rotateZ(Math.PI * 0.5)
    const geometry = new THREE.InstancedBufferGeometry()
    geometry.index = t.index
    geometry.attributes = t.attributes

    geometry.setAttribute('index', new THREE.InstancedBufferAttribute(indexes, 1))
    geometry.setAttribute('instancePosition', new THREE.InstancedBufferAttribute(positions, 3))
    geometry.setAttribute('color', new THREE.InstancedBufferAttribute(colors, 3))
    geometry.setAttribute('scale', new THREE.InstancedBufferAttribute(scales, 1))
    geometry.setAttribute('opacity', new THREE.InstancedBufferAttribute(opacities, 1))

    const material = new THREE.ShaderMaterial(cloneDeep(pointShader))
    const mesh = new THREE.InstancedMesh(geometry, material, scales.length)
    mesh.frustumCulled = false
    mesh.matrixAutoUpdate = false
    parentRefCurrent.add(mesh)

    geoRef.current = mesh

    return () => parentRefCurrent.remove(mesh)
  }, [positions, colors, scales, opacities, indexes, props.shape])

  useEffect(() => {

  }, [props.count])

  useEffect(() => {
    geoRef.current.material.uniforms.bounds.value = props.bounds || (
      [0, 1000]
    )
    geoRef.current.count = props.bounds[1]
  }, [props.bounds])

  useFrame(() => {
    geoRef.current.material.uniformsNeedUpdate = true
    geoRef.current.geometry.attributes.instancePosition.needsUpdate = true
    geoRef.current.geometry.attributes.color.needsUpdate = true
    geoRef.current.geometry.attributes.scale.needsUpdate = true
    geoRef.current.geometry.attributes.opacity.needsUpdate = true
  })

  return <group ref={parentRef} renderOrder={0} />
}
